export default __webpack_public_path__ + "static/media/newsletter-element-2.7d63bde3.svg";